import { baseApi } from "./baseApi"
import type { TableQueryParams } from "../../types/api"
import { withTableQuery } from "./queryParams"

export interface AuditLogRow {
  id: string
  action?: string
  entityType?: string
  entityId?: string
  createdAt?: string
  [key: string]: unknown
}

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAuditLogs: build.query<AuditLogRow[], TableQueryParams | void>({
      query: (params) => ({ url: withTableQuery("/audit-logs", params || undefined), adminApi: "v1" }),
      providesTags: [{ type: "Report", id: "AUDIT_LOGS" }],
    }),
  }),
})

export const { useGetAuditLogsQuery } = reportsApi
